import type { TOC } from '@ember/component/template-only';

interface LoaderSvgComponentInterface {
	Element: HTMLDivElement;
	Args: object;
}

const LoaderSvgComponent: TOC<LoaderSvgComponentInterface> = <template>
	<span class="loader-svg">&nbsp;</span>
</template>;

export default LoaderSvgComponent;
